var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.3,13.2h0.2v1.6h14.6L19,12.2h-1.8l-0.5-1.8h-5.3v2.5H5.7C5.5,12.8,5.3,13,5.3,13.2z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1.7,
    y: 12.8,
    style: {
      fill: "#000"
    },
    width: 0.1,
    height: 2.9
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M1.6,13.1c-0.1,0-0.2-0.1-0.2-0.2c0-0.1,0-0.3,0-0.4c0-0.1,0-0.2,0.1-0.2c0,0,0.1-0.1,0.2-0.1 c1.6,0.1,3,1.2,3.9,2.8c-0.2,0.2-0.4,0.4-0.7,0.5C4.2,14.1,3,13.2,1.6,13.1z"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1,16.5L1.1,16l0-0.2c0-0.2,0.1-0.4,0.3-0.4l1.9-0.7c0.7-0.3,1.5-0.4,2.2-0.4H14c0.1,0,0.3,0,0.4-0.2l0.6-0.5 c0.1-0.1,0.3-0.1,0.4-0.1H23l-0.7,1.1l-1.4,2.1c-0.4,0.6-1.1,1-1.7,1H15h-2.9H1.8c-0.2,0-0.4-0.1-0.6-0.3C1,17,1,16.8,1,16.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5,9.9h5.4c0.2,0,0.3,0.2,0.3,0.4h-5.7V9.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M14.4,10.7v1.1c0,0.1,0.1,0.2,0.2,0.2h0.8c0.1,0,0.2-0.1,0.2-0.2v-1.1c0-0.1-0.1-0.2-0.2-0.2h-0.8 C14.4,10.5,14.3,10.6,14.4,10.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M13,10.7v1.1c0,0.1,0.1,0.2,0.2,0.2H14c0.1,0,0.2-0.1,0.2-0.2v-1.1c0-0.1-0.1-0.2-0.2-0.2h-0.8 C13.1,10.5,13,10.6,13,10.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M15.7,10.7v1.1c0,0.1,0.1,0.2,0.2,0.2h0.8c0.1,0,0.2-0.1,0.2-0.3l-0.3-1.1c0-0.1-0.1-0.1-0.2-0.1h-0.5 C15.8,10.5,15.7,10.6,15.7,10.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M11.7,10.7v1.1c0,0.1,0.1,0.2,0.2,0.2h0.8c0.1,0,0.2-0.1,0.2-0.2v-1.1c0-0.1-0.1-0.2-0.2-0.2h-0.8 C11.8,10.5,11.7,10.6,11.7,10.7z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M18.3,13.3v-0.5c0-0.1,0-0.1,0.1-0.1H19c0,0,0.1,0,0.1,0.1l0.2,0.5c0,0.1,0,0.2-0.1,0.2h-0.8 C18.3,13.4,18.3,13.4,18.3,13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M18.1,13.3v-0.5c0-0.1,0-0.1-0.1-0.1h-0.6c0,0-0.1,0-0.1,0.1v0.5c0,0.1,0,0.1,0.1,0.1H18 C18.1,13.4,18.2,13.4,18.1,13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M17.2,13.3v-0.5c0-0.1,0-0.1-0.1-0.1h-0.6c0,0-0.1,0-0.1,0.1v0.5c0,0.1,0,0.1,0.1,0.1h0.6 C17.2,13.4,17.2,13.4,17.2,13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M16.3,13.3v-0.5c0-0.1,0-0.1-0.1-0.1h-0.6c0,0-0.1,0-0.1,0.1v0.5c0,0.1,0,0.1,0.1,0.1h0.6 C16.2,13.4,16.3,13.4,16.3,13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M15.3,13.3v-0.5c0-0.1,0-0.1-0.1-0.1h-0.6c0,0-0.1,0-0.1,0.1v0.5c0,0.1,0,0.1,0.1,0.1h0.6 C15.3,13.4,15.4,13.4,15.3,13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M14.4,13.3v-0.5c0-0.1,0-0.1-0.1-0.1h-0.6c0,0-0.1,0-0.1,0.1v0.5c0,0.1,0,0.1,0.1,0.1h0.6 C14.3,13.4,14.4,13.4,14.4,13.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.3,
    y: 9.6,
    style: {
      fill: "#000"
    },
    width: 0.7,
    height: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M14.4,9.6h0.5l-0.1-0.5c0-0.1-0.1-0.1-0.1-0.1h-0.1c0,0-0.1,0-0.1,0.1L14.4,9.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M14.6,9.1c0,0,0-1.5-0.6-2.6c0,0,0-0.1,0-0.1c0,0,0,0,0,0C14.7,7.6,14.7,9.1,14.6,9.1 C14.7,9.1,14.7,9.1,14.6,9.1L14.6,9.1C14.6,9.1,14.6,9.1,14.6,9.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M12.8,15.2c0,0.2,0.1,0.3,0.3,0.3c0.1,0,0.3-0.1,0.3-0.3s-0.1-0.3-0.3-0.3C12.9,14.9,12.8,15.1,12.8,15.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M11.1,15.2c0,0.2,0.1,0.3,0.3,0.3s0.3-0.1,0.3-0.3s-0.1-0.3-0.3-0.3C11.2,14.9,11.1,15.1,11.1,15.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M9.4,15.2c0,0.2,0.1,0.3,0.3,0.3c0.1,0,0.3-0.1,0.3-0.3s-0.1-0.3-0.3-0.3C9.5,14.9,9.4,15.1,9.4,15.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M7.7,15.2c0,0.2,0.1,0.3,0.3,0.3s0.3-0.1,0.3-0.3S8.1,14.9,8,14.9S7.7,15.1,7.7,15.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M6,15.2c0,0.2,0.1,0.3,0.3,0.3s0.3-0.1,0.3-0.3s-0.1-0.3-0.3-0.3C6.1,14.9,6,15.1,6,15.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShip);
export default __webpack_public_path__ + "static/media/ship.5a12d9065164b3b68abe98ceae3e510f.svg";
export { ForwardRef as ReactComponent };